import React, {useEffect, useState} from 'react'
import {Button, Checkbox, DatePicker, Form, Input, message, Modal, Radio, Switch} from 'antd'
import {useNavigate, useRevalidator} from 'react-router-dom'
import {AuthError, PostgrestError} from '@supabase/supabase-js'
import {instance as userService} from '../../services/UserService'

import {useIntl} from 'react-intl'
import {passwordRegexp} from './util'

const validateMessages = {
  required: '${label} is required!',
}

export type ChangePasswordFormProps = {
  setEmailSent: (isEmailSent: boolean) => void
}

export function ChangePasswordForm(props: ChangePasswordFormProps) {
  const [form] = Form.useForm()

  const [isSubmitting, setSubmitting] = useState(false)
  const revalidator = useRevalidator()
  const [messageApi, contextHolder] = message.useMessage()

  const intl = useIntl()
  const navigate = useNavigate()

  const password1 = Form.useWatch('password1', form)
  const password2 = Form.useWatch('password2', form)

  const passwordsMatch = password1 === password2

  return (
    <div>
      {contextHolder}

      <Form
        form={form}
        layout="vertical"
        style={{width: 500}}
        validateMessages={validateMessages}
        onFinish={async (formState) => {
          setSubmitting(true)
          let result: {success: boolean; error?: AuthError}
          const signUp = {
            password1: formState.password1,
            password2: formState.password2,
          }
          setSubmitting(false)
          if (passwordsMatch) {
            result = await userService.changePassword(signUp.password1)
            if (result.success) {
              revalidator.revalidate()
              navigate('/login')
              //props.setEmailSent(true)
            } else {
              messageApi.open({
                type: 'error',
                content: result.error?.message,
              })
            }
          }
        }}
      >
        <Form.Item
          name="password1"
          label={intl.formatMessage({id: 'newPassword'})}
          rules={[{required: true}]}
          help={
            password1
              ? password1.match(passwordRegexp)
                ? ''
                : intl.formatMessage({id: 'passwordValidation'})
              : ''
          }
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="password2"
          label={intl.formatMessage({id: 'repeatNewPassword'})}
          rules={[{required: true}]}
          validateStatus={passwordsMatch ? '' : 'error'}
          help={passwordsMatch ? '' : intl.formatMessage({id: 'passwordMismatch'})}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button htmlType="submit" size="large" type="primary" style={{width: '100%'}}>
            {intl.formatMessage({id: 'continue'})}
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}
